
import React from 'react'

import createBlockTypeButton from './util/createBlockTypeButton';

export default createBlockTypeButton({
  blockType: 'unordered-list-item',
  children: (
    <i className={"fa fa-list-ul"} aria-hidden="true"></i>
  ),
});
